// async polyfills do not load properly.

import './closest';
import './insertAdjacentSvg';
import './replaceAll';
